import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { MismoChangeBadgeConfig, MismoChangeType } from '../../ImportMismoIntoLoanModal.constants';
import { ImportMismoIntoLoanModalTestIds } from '../../ImportMismoIntoLoanModal.testIds';
import { formatChangeValue } from '../../ImportMismoIntoLoanModal.utils';

import {
  arrowStyles,
  cardStyles,
  cardTopRowStyles,
  currentValueStyles,
  fieldNameStyles,
  getBadgeStyles,
  incomingValueStyles,
  valueDiffRowStyles,
} from './MismoChangeCard.styles';

const MismoChangeCard = ({ change }) => {
  const badgeConfig = MismoChangeBadgeConfig[change.changeType];
  const isAdded = change.changeType === MismoChangeType.ADDED;

  return (
    <Box data-testid={ImportMismoIntoLoanModalTestIds.CHANGE_CARD} sx={cardStyles}>
      <Box sx={cardTopRowStyles}>
        <Typography sx={fieldNameStyles} variant="bold14">
          {change.field}
        </Typography>
        <Typography component="span" sx={getBadgeStyles(badgeConfig)} variant="bold12">
          {badgeConfig.label}
        </Typography>
      </Box>

      {isAdded ? (
        <Typography sx={incomingValueStyles} variant="regular14">
          {formatChangeValue(change.incomingValue)}
        </Typography>
      ) : (
        <Box sx={valueDiffRowStyles}>
          <Typography sx={currentValueStyles} variant="regular14">
            {formatChangeValue(change.currentValue)}
          </Typography>
          <Typography sx={arrowStyles} variant="regular14">
            →
          </Typography>
          <Typography sx={incomingValueStyles} variant="regular14">
            {formatChangeValue(change.incomingValue)}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

MismoChangeCard.propTypes = {
  change: PropTypes.shape({
    field: PropTypes.string,
    currentValue: PropTypes.string,
    incomingValue: PropTypes.string,
    changeType: PropTypes.oneOf(Object.values(MismoChangeType)),
  }).isRequired,
};

export default memo(MismoChangeCard);
